import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';
import type { IDeleteChallengeClipRequest } from './delete-challenge-clip-request';
import type { IDeleteChallengeClipResponse } from './delete-challenge-clip-response';
import { deleteChallengeClipResponseSchema } from './delete-challenge-clip-response';

export async function deleteChallengeClipApi({
  challengeId,
  clipId,
}: IDeleteChallengeClipRequest): Promise<IValidatedResponse<IDeleteChallengeClipResponse>> {
  return deleteRequest<IDeleteChallengeClipResponse>({
    path: `/sys/challenges/${challengeId}/clips/${clipId}`,
    schema: deleteChallengeClipResponseSchema,
  });
}
